/* Front Line Holster Finder — pistol -> carry -> retention -> holsters molded for that pistol.
   Index: assets/fitment-index.json. Live price/image: /products/<handle>.js. Remembers the pistol via window.FLGun. */
(function () {
  var root = document.querySelector('[data-flf]'); if (!root) return;
  var app = root.querySelector('[data-flf-app]'), summary = root.querySelector('[data-flf-summary]');
  var CONTACT = root.getAttribute('data-contact') || '/pages/contact';
  var CARRY = [
    { k: 'iwb', n: 'Concealed · IWB', d: 'Inside the waistband, under a shirt. Everyday carry.' },
    { k: 'owb', n: 'Belt · OWB', d: 'Outside the waistband: open carry, or under a jacket.' },
    { k: 'duty', n: 'Duty & retention', d: 'Level II–III locks for uniformed and tactical carry.' },
    { k: 'dropleg', n: 'Drop leg', d: 'Thigh-mounted, clear of vests and plate carriers.' },
    { k: 'shoulder', n: 'Shoulder', d: 'Under a jacket. Comfortable for driving and long sits.' },
    { k: 'ankle', n: 'Ankle', d: 'Deep concealment, or a backup gun.' },
    { k: 'pocket', n: 'Pocket', d: 'For compact pistols, front or rear pocket.' }
  ];
  var RET = {
    1: { n: 'Level I · Open top', d: 'Passive retention and the fastest draw.' },
    2: { n: 'Level II', d: 'One active lock: thumb break, RetenScrews or the SR™ trigger-guard lock.' },
    3: { n: 'Level III', d: 'HDL™ Head Lock, duty grade. Two deliberate actions to draw.' }
  };
  var NO_RET_STEP = { iwb: 1, shoulder: 1, ankle: 1, pocket: 1 };
  var idx = null, S = { b: null, l: null, carry: null, ret: null, view: 'gun', allBrands: false };
  var live = {}, hot = {};

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function brandOf(n) { return idx.brands.find(function (b) { return b.n === n; }); }
  function modelOf(b, l) { var B = brandOf(b); return B && B.m.find(function (m) { return m.l === l; }); }
  function gunName() { return S.b ? (brandOf(S.b) || {}).d + ' ' + S.l : ''; }
  function shortGun() { return S.b ? (brandOf(S.b) || {}).d + ' ' + S.l.replace(/\s[\d.]+"$/, '') : ''; }
  function fitting() {
    var m = modelOf(S.b, S.l); if (!m) return [];
    var seen = {}, out = [];
    m.t.forEach(function (ti) { idx.templates[ti].forEach(function (pi) { if (!seen[pi]) { seen[pi] = 1; out.push(idx.products[pi]); } }); });
    return out;
  }
  function carryMatch(p, k) { return !k || k === 'all' || p.c.split(' ').indexOf(k) > -1; }
  function filtered() { return fitting().filter(function (p) { return carryMatch(p, S.carry) && (!S.ret || S.ret === 'any' || String(p.r) === String(S.ret)); }); }
  function needsRet(list) { if (!S.carry || S.carry === 'all' || NO_RET_STEP[S.carry]) return false; var lv = {}; list.forEach(function (p) { lv[p.r] = 1; }); return Object.keys(lv).length > 1; }
  function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }

  /* ---------- URL / history ---------- */
  function readUrl() {
    var q = new URLSearchParams(location.search), g = q.get('gun');
    if (g && g.indexOf('|') > 0) { var i = g.indexOf('|'); S.b = g.slice(0, i); S.l = g.slice(i + 1); }
    else { var r = window.FLGun && FLGun.get(); if (r) { S.b = r.b; S.l = r.l; } }
    if (S.b && !modelOf(S.b, S.l)) { S.b = S.l = null; }
    S.carry = q.get('carry'); S.ret = q.get('ret');
    if (S.carry && S.carry !== 'all' && !CARRY.some(function (c) { return c.k === S.carry; })) S.carry = null;
    S.view = q.get('step') || (S.b ? (S.carry ? 'results' : 'carry') : 'gun');
    if (S.view === 'model' && q.get('brand')) { S.b = q.get('brand'); S.l = null; }
    if (!S.b && S.view !== 'gun' && S.view !== 'model') S.view = 'gun';
  }
  function writeUrl(push) {
    var q = new URLSearchParams(location.search);
    ['gun', 'carry', 'ret', 'step', 'brand'].forEach(function (k) { q.delete(k); });
    if (S.view === 'model') { q.set('step', 'model'); q.set('brand', S.b); }
    if (S.l) q.set('gun', S.b + '|' + S.l);
    if (S.carry && S.view !== 'carry') q.set('carry', S.carry);
    if (S.ret && S.view === 'results') q.set('ret', S.ret);
    if (S.view === 'ret' || S.view === 'carry') q.set('step', S.view);
    var url = location.pathname + (q.toString() ? '?' + q.toString() : '');
    try { history[push ? 'pushState' : 'replaceState']({ flf: 1 }, '', url); } catch (e) {}
  }
  function go(view, push) {
    S.view = view; writeUrl(push !== false); render();
    try {   /* bring the new question into view under the sticky header, without jumping back to the hero */
      var body = root.querySelector('.flf__body'), head = document.querySelector('.header, header, [data-section-type="header"]');
      var top = body.getBoundingClientRect().top + window.pageYOffset - ((head && head.getBoundingClientRect().height) || 0) - 12;
      if (window.pageYOffset > top || window.pageYOffset < top - window.innerHeight * 0.5) window.scrollTo({ top: top, behavior: 'smooth' });
    } catch (e) {}
  }
  window.addEventListener('popstate', function () { readUrl(); render(); });

  /* ---------- chrome ---------- */
  function stepper() {
    var order = ['gun', 'carry', 'ret', 'results'], cur = S.view === 'model' ? 'gun' : S.view, ci = order.indexOf(cur);
    root.querySelectorAll('[data-flf-step]').forEach(function (li) {
      var i = order.indexOf(li.getAttribute('data-flf-step'));
      li.classList.toggle('is-on', i === ci); li.classList.toggle('is-done', i < ci);
    });
  }
  function chips() {
    if (!S.l) { summary.hidden = true; summary.innerHTML = ''; return; }
    var h = '<button class="flf__chip" type="button" data-act="change-gun">Pistol: <b>' + esc(gunName()) + '</b> <i>Change</i></button>';
    if (S.carry && S.view !== 'carry') {
      var c = S.carry === 'all' ? 'All carry styles' : (CARRY.find(function (x) { return x.k === S.carry; }) || {}).n;
      h += '<button class="flf__chip" type="button" data-act="change-carry">Carry: <b>' + esc(c) + '</b> <i>Change</i></button>';
    }
    if (S.ret && S.ret !== 'any' && S.view === 'results') h += '<button class="flf__chip" type="button" data-act="change-ret">Retention: <b>' + esc(RET[S.ret].n) + '</b> <i>Change</i></button>';
    summary.innerHTML = h; summary.hidden = false;
  }

  /* ---------- views ---------- */
  function vGun() {
    var top = idx.brands.filter(function (b) { return b.top; });
    var rest = idx.brands.filter(function (b) { return !b.top; }).sort(function (a, b) { return a.d.localeCompare(b.d); });
    var tile = function (b) { return '<button class="flf__tile flf__tile--brand" type="button" data-brand="' + esc(b.n) + '"><b>' + esc(b.d) + '</b><small>' + plural(b.m.length, 'model') + '</small></button>'; };
    return '<h2 class="flf__h ff-heading">Which pistol do you carry?</h2><p class="flf__sub">Type it, or pick the brand. ' + idx.brands.reduce(function (n, b) { return n + b.m.length; }, 0) + ' pistol models, each with holsters molded for it.</p>' +
      '<div class="flf__search"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
      '<input type="search" id="flf-q" autocomplete="off" placeholder="Search your pistol, e.g. Glock 19" aria-label="Search your pistol" aria-autocomplete="list" aria-controls="flf-suggest">' +
      '<ul class="flf__suggest" id="flf-suggest" role="listbox" hidden></ul></div>' +
      '<div class="flf__grid">' + top.map(tile).join('') + (S.allBrands ? rest.map(tile).join('') : '') + '</div>' +
      (S.allBrands ? '' : '<p class="flf__more"><button class="flf__link" type="button" data-act="all-brands">All ' + idx.brands.length + ' brands</button></p>');
  }
  function vModel() {
    var B = brandOf(S.b); if (!B) return vGun();
    return '<h2 class="flf__h ff-heading">' + esc(B.d) + ': which model?</h2><p class="flf__sub">Barrel length is shown so you pick the exact one.</p>' +
      '<div class="flf__grid">' + B.m.map(function (m) {
        var n = {}; m.t.forEach(function (ti) { idx.templates[ti].forEach(function (pi) { n[pi] = 1; }); });
        return '<button class="flf__tile" type="button" data-model="' + esc(m.l) + '"><b>' + esc(m.l) + '</b><small>' + plural(Object.keys(n).length, 'holster') + '</small></button>';
      }).join('') + '</div><p class="flf__more"><button class="flf__link" type="button" data-act="change-gun">← All brands</button></p>';
  }
  function vCarry() {
    var all = fitting();
    var opts = CARRY.map(function (c) { return { c: c, n: all.filter(function (p) { return carryMatch(p, c.k); }).length }; }).filter(function (x) { return x.n; });
    return '<h2 class="flf__h ff-heading">How will you carry your ' + esc(gunName()) + '?</h2><p class="flf__sub">' + plural(all.length, 'holster') + (all.length === 1 ? ' is' : ' are') + ' molded for it. Pick a carry style.</p>' +
      '<div class="flf__options">' + opts.map(function (x) { return '<button class="flf__opt" type="button" data-carry="' + x.c.k + '"><b>' + esc(x.c.n) + '</b><em>' + plural(x.n, 'holster') + '</em><span>' + esc(x.c.d) + '</span></button>'; }).join('') +
      '<button class="flf__opt flf__opt--all" type="button" data-carry="all"><b>Show me everything</b><em>' + all.length + '</em><span>Every holster made for your ' + esc(gunName()) + '.</span></button></div>';
  }
  function vRet() {
    var list = fitting().filter(function (p) { return carryMatch(p, S.carry); }), lv = {};
    list.forEach(function (p) { lv[p.r] = (lv[p.r] || 0) + 1; });
    return '<h2 class="flf__h ff-heading">How much retention?</h2><p class="flf__sub">Retention is how firmly the holster holds the pistol until you draw.</p>' +
      '<div class="flf__options">' + [1, 2, 3].filter(function (r) { return lv[r]; }).map(function (r) { return '<button class="flf__opt" type="button" data-ret="' + r + '"><b>' + esc(RET[r].n) + '</b><em>' + plural(lv[r], 'holster') + '</em><span>' + esc(RET[r].d) + '</span></button>'; }).join('') +
      '<button class="flf__opt flf__opt--all" type="button" data-ret="any"><b>Any level</b><em>' + list.length + '</em><span>Show all of them.</span></button></div>';
  }
  function vResults() {
    var base = fitting(), list = filtered().slice().sort(function (a, b) { return (b.s - a.s) || (b.b - a.b) || a.t.localeCompare(b.t); });
    var rank = idx.products.slice().sort(function (a, b) { return b.s - a.s; }).slice(0, 8).map(function (p) { return p.h; });
    var avail = CARRY.filter(function (c) { return base.some(function (p) { return carryMatch(p, c.k); }); });
    var m = modelOf(S.b, S.l), gp = window.FLGun ? FLGun.param({ b: S.b, l: S.l }) : '';
    var h = '<div class="flf__results-head"><div><h2 class="flf__h ff-heading">' + plural(list.length, 'holster') + ' made for your ' + esc(gunName()) + '</h2>' +
      '<p class="flf__sub" style="margin:0">Sorted by what other ' + esc((brandOf(S.b) || {}).d) + ' owners buy most.</p></div></div>' +
      '<div class="flf__filters" role="group" aria-label="Carry style"><button class="flf__filter" type="button" data-carry="all" aria-pressed="' + (!S.carry || S.carry === 'all') + '">All (' + base.length + ')</button>' +
      avail.map(function (c) { return '<button class="flf__filter" type="button" data-carry="' + c.k + '" aria-pressed="' + (S.carry === c.k) + '">' + esc(c.n) + '</button>'; }).join('') + '</div>';
    if (!list.length) {
      h += '<div class="flf__empty"><p>No holsters match this combination yet.</p><button class="flf__link" type="button" data-carry="all">See all ' + base.length + ' holsters for your ' + esc(gunName()) + '</button></div>';
    } else {
      h += '<div class="flf__cards">' + list.map(function (p) {
        var meta = [p.m, p.r === 1 ? 'Level I' : 'Level ' + p.r].filter(Boolean).join(' · ');
        return '<a class="flf__card" href="/products/' + encodeURIComponent(p.h) + (gp ? '?gun=' + gp : '') + '" data-h="' + esc(p.h) + '">' +
          '<div class="flf__img flf__skel">' + (rank.indexOf(p.h) > -1 ? '<span class="flf__badge">Best seller</span>' : '') + '</div>' +
          '<div class="flf__card-body"><span class="flf__card-title">' + esc(p.t) + '</span><span class="flf__meta">' + esc(meta) + '</span>' +
          '<span class="flf__fit">Fits your ' + esc(shortGun()) + '</span><span class="flf__price" data-price>&nbsp;</span><span class="flf__cta">View holster</span></div></a>';
      }).join('') + '</div>';
    }
    h += '<p class="flf__note">Using an optic, a weapon light or a modified pistol? <a href="' + esc(CONTACT) + '">Contact us</a> before you order and we’ll confirm the fit.' +
      (m && m.pg ? ' &nbsp;·&nbsp; <a href="/collections/' + esc(m.pg) + '">Read the ' + esc(gunName().replace(/\s[\d.]+"$/, '')) + ' holster guide</a>' : '') + '</p>';
    return h;
  }

  /* ---------- live product data ---------- */
  function money(cents) {
    try { var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function product(h) {
    if (!live[h]) live[h] = fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return live[h];
  }
  function hydrate() {
    var cards = app.querySelectorAll('.flf__card[data-h]'), q = Array.prototype.slice.call(cards), active = 0;
    function next() {
      while (active < 6 && q.length) {
        var card = q.shift(); active++;
        (function (card) {
          product(card.getAttribute('data-h')).then(function (p) {
            active--; next();
            if (!p) return;
            var box = card.querySelector('.flf__img'), pool = [p.featured_image].concat(p.images || []).filter(Boolean), img = pool.shift();  /* same main photo as the store's collection grids */
            if (img && box) {
              if (img.indexOf('//') === 0) img = 'https:' + img;
              var el = new Image(); el.alt = p.title; el.loading = 'lazy'; el.decoding = 'async';
              el.src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=520';
              el.onload = function () { box.classList.remove('flf__skel'); };
              el.onerror = function () { var n = pool.shift(); if (n) { if (n.indexOf('//') === 0) n = 'https:' + n; el.src = n + (n.indexOf('?') > -1 ? '&' : '?') + 'width=520'; } else box.classList.remove('flf__skel'); };
              box.appendChild(el);
            }
            var pr = card.querySelector('[data-price]');
            if (pr) pr.textContent = (p.price_varies ? 'From ' : '') + money(p.price);
          });
        })(card);
      }
    }
    next();
  }

  /* ---------- search ---------- */
  var entries = null;
  function buildEntries() {
    entries = [];
    idx.brands.forEach(function (b, bi) { b.m.forEach(function (m) { entries.push({ b: b.n, d: b.d, l: m.l, bi: bi, key: norm(b.d + ' ' + b.n + ' ' + m.l) }); }); });
  }
  function suggest(input) {
    var list = root.querySelector('#flf-suggest'), raw = input.value.trim();
    if (!raw) { list.hidden = true; list.innerHTML = ''; return; }
    if (!entries) buildEntries();
    var toks = raw.toLowerCase().split(/\s+/).map(norm).filter(Boolean), joined = norm(raw);
    var hits = entries.filter(function (e) { return e.key.indexOf(joined) > -1 || toks.every(function (t) { return e.key.indexOf(t) > -1; }); })
      .sort(function (a, b) { return a.bi - b.bi || a.l.localeCompare(b.l, 'en', { numeric: true }); }).slice(0, 8);
    list.innerHTML = hits.length ? hits.map(function (e, i) { return '<li><button type="button" role="option" aria-selected="' + (i === 0) + '" data-pick-b="' + esc(e.b) + '" data-pick-l="' + esc(e.l) + '">' + esc(e.d + ' ' + e.l) + '<small>select</small></button></li>'; }).join('')
      : '<li><button type="button" disabled>No match. Try the brand name, or <u>contact us</u>.</button></li>';
    list.hidden = false;
  }

  /* ---------- render + events ---------- */
  function render() {
    stepper(); chips();
    var v = S.view, html;
    if (v === 'model') html = vModel();
    else if (v === 'carry' && S.l) html = vCarry();
    else if (v === 'ret' && S.l) html = vRet();
    else if (v === 'results' && S.l) html = vResults();
    else { S.view = 'gun'; html = vGun(); stepper(); }
    app.innerHTML = '<div class="flf__view">' + html + '</div>';
    if (S.view === 'results') { hydrate(); trackResults(); }
    var q = app.querySelector('#flf-q');
    if (q) {
      q.addEventListener('input', function () { suggest(q); });
      q.addEventListener('keydown', function (e) {
        var opts = Array.prototype.slice.call(app.querySelectorAll('#flf-suggest [data-pick-b]')); if (!opts.length) return;
        var i = opts.findIndex(function (o) { return o.getAttribute('aria-selected') === 'true'; });
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); opts.forEach(function (o) { o.setAttribute('aria-selected', 'false'); }); i = (i + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length; opts[i].setAttribute('aria-selected', 'true'); opts[i].scrollIntoView({ block: 'nearest' }); }
        if (e.key === 'Enter') { e.preventDefault(); opts[Math.max(0, i)].click(); }
      });
    }
  }
  /* measurement: FLGun.track / FLGun.attrs (snippets/fl-gun-head.liquid); the order gets _fl_finder = first use date */
  var lastResults = '';
  function trackResults() {
    if (!window.FLGun || !FLGun.track) return;
    var key = [S.b, S.l, S.carry, S.ret].join('|'); if (key === lastResults) return; lastResults = key;
    FLGun.track('fl_finder_results', { fl_gun: FLGun.label({ b: S.b, l: S.l }), fl_carry: S.carry || 'all', fl_retention: S.ret || 'any', fl_count: app.querySelectorAll('.flf__card').length });
    var first = new Date().toISOString().slice(0, 10), done = false;
    try { first = localStorage.getItem('fl.finder') || first; localStorage.setItem('fl.finder', first); done = sessionStorage.getItem('fl.finder.attr') === '1'; sessionStorage.setItem('fl.finder.attr', '1'); } catch (e) {}
    if (!done) setTimeout(function () { FLGun.attrs({ _fl_finder: first }); }, 1500);   /* after the gun's own cart write */
  }
  app.addEventListener('click', function (e) {
    var a = e.target.closest('a.flf__card');
    if (a && window.FLGun && FLGun.track) FLGun.track('fl_finder_click', { fl_gun: FLGun.label({ b: S.b, l: S.l }), fl_product: a.getAttribute('data-h') });
  });
  function pickGun(b, l) { S.b = b; S.l = l; S.carry = null; S.ret = null; if (window.FLGun) FLGun.set({ b: b, l: l }, 'finder'); go('carry'); }
  function pickCarry(k) {
    S.carry = k; S.ret = null;
    if (S.view === 'results') { writeUrl(false); render(); return; }
    var list = fitting().filter(function (p) { return carryMatch(p, k); });
    go(needsRet(list) ? 'ret' : 'results');
  }
  app.addEventListener('click', function (e) {
    var t = e.target.closest('button'); if (!t || t.disabled) return;
    if (t.hasAttribute('data-pick-b')) return pickGun(t.getAttribute('data-pick-b'), t.getAttribute('data-pick-l'));
    if (t.hasAttribute('data-brand')) { S.b = t.getAttribute('data-brand'); S.l = null; var B = brandOf(S.b); if (B && B.m.length === 1) return pickGun(B.n, B.m[0].l); return go('model'); }
    if (t.hasAttribute('data-model')) return pickGun(S.b, t.getAttribute('data-model'));
    if (t.hasAttribute('data-carry')) return pickCarry(t.getAttribute('data-carry'));
    if (t.hasAttribute('data-ret')) { S.ret = t.getAttribute('data-ret'); return go('results'); }
    var act = t.getAttribute('data-act');
    if (act === 'all-brands') { S.allBrands = true; render(); }
    if (act === 'change-gun') { S.b = S.l = null; S.carry = S.ret = null; go('gun'); }
  });
  summary.addEventListener('click', function (e) {
    var t = e.target.closest('[data-act]'); if (!t) return; var act = t.getAttribute('data-act');
    if (act === 'change-gun') { S.b = S.l = null; S.carry = S.ret = null; go('gun'); }
    if (act === 'change-carry') { S.ret = null; go('carry'); }
    if (act === 'change-ret') go('ret');
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('.flf__search')) { var l = root.querySelector('#flf-suggest'); if (l) l.hidden = true; } });

  fetch(root.getAttribute('data-index') || (window.FLGun && FLGun.indexUrl)).then(function (r) { return r.json(); }).then(function (data) {
    idx = data; readUrl(); writeUrl(false); render();
  }).catch(function () {
    app.innerHTML = '<p class="flf__note">The holster finder could not load. <a href="/collections/all">Browse all holsters</a> or <a href="' + esc(CONTACT) + '">contact us</a>.</p>';
  });
})();
